export const ProjectMap = {
  0: {
    typeName: "projects:tags.hackathon",
    typeColor: "#ff9800",
  },
  1: {
    typeName: "projects:tags.personal",
    typeColor: "#00e676",
  },
  2: {
    typeName: "projects:tags.academic",
    typeColor: "#7c4dff",
  },
  3: {
    typeName: "projects:tags.research",
    typeColor: "#00b0ff",
  },
};

export const ProjectItems = [
  {
    projectName: "projects:projects.project9.name",
    projectType: 1,
    imageLink: "/images/projects/marathonizer.png",
    projectDescription: "projects:projects.project9.description",
    projectLink: "https://github.com/BriannHu/MarathonTrainer",
    tags: [
      {
        name: "React.js",
      },
      {
        name: "Material UI",
      },
      {
        name: "Redux",
      },
      {
        name: "MongoDB",
      },
      {
        name: "Express.js",
      },
      {
        name: "Google OAuth",
      },
    ],
  },
  {
    projectName: "projects:projects.project8.name",
    projectType: 0,
    imageLink: "/images/projects/asl_transcriber.png",
    projectDescription: "projects:projects.project8.description",
    projectLink: "https://github.com/BriannHu/ASL_Alphabet_Interpretation",
    tags: [
      {
        name: "Python",
      },
      {
        name: "OpenCV",
      },
      {
        name: "Mediapipe",
      },
    ],
  },
  {
    projectName: "projects:projects.project7.name",
    projectType: 3,
    imageLink: "/images/projects/nserc_project.png",
    projectDescription: "projects:projects.project7.description",
    projectLink: "https://github.com/BriannHu/NSERC_Project",
    tags: [
      {
        name: "RocksDB",
      },
      {
        name: "C",
      },
      {
        name: "C++",
      },
    ],
  },
  {
    projectName: "projects:projects.project6.name",
    projectType: 1,
    imageLink: "/images/projects/personal_website_v2.png",
    projectDescription: "projects:projects.project6.description",
    projectLink: "https://github.com/BriannHu/Personal-Website-V2",
    tags: [
      {
        name: "React.js",
      },
      {
        name: "Material UI",
      },
      {
        name: "Procreate",
      },
    ],
  },
  {
    projectName: "projects:projects.project5.name",
    projectType: 2,
    imageLink: "/images/projects/pseudo_os.png",
    projectDescription: "projects:projects.project5.description",
    projectLink:
      "https://www.mcgill.ca/deanofstudents/students/student-rights-responsibilities/code",
    tags: [
      {
        name: "C",
      },
    ],
  },
  {
    projectName: "projects:projects.project4.name",
    projectType: 1,
    imageLink: "/images/projects/discs_website.png",
    projectDescription: "projects:projects.project4.description",
    projectLink: "https://github.com/BriannHu/DISCS-Website",
    tags: [
      {
        name: "React.js",
      },
      {
        name: "React-Bootstrap",
      },
      {
        name: "HTML/CSS",
      },
    ],
  },
  {
    projectName: "projects:projects.project3.name",
    projectType: 0,
    imageLink: "/images/projects/covid_visualizer.png",
    projectDescription: "projects:projects.project3.description",
    projectLink: "https://github.com/BriannHu/Covid19Visualizer",
    tags: [
      {
        name: "Python",
      },
      {
        name: "Dash",
      },
      {
        name: "HTML/CSS",
      },
      {
        name: "Heroku",
      },
      {
        name: "Github Actions",
      },
    ],
  },
  {
    projectName: "projects:projects.project2.name",
    projectType: 2,
    imageLink: "/images/projects/toy_language.png",
    projectDescription: "projects:projects.project2.description",
    projectLink:
      "https://www.mcgill.ca/deanofstudents/students/student-rights-responsibilities/code",
    tags: [
      {
        name: "OCaml",
      },
    ],
  },
  {
    projectName: "projects:projects.project1.name",
    projectType: 1,
    imageLink: "/images/projects/personal_website_v1.png",
    projectDescription: "projects:projects.project1.description",
    projectLink: "https://github.com/BriannHu/PortfolioV1",
    tags: [
      {
        name: "HTML/CSS",
      },
      {
        name: "SCSS",
      },
      {
        name: "Javascript",
      },
    ],
  },
];
